<template>
  <div class="case-detail">
    <div class="case-title d-flex-between" style="align-items: center">
      <div>{{ cardInfo.type_name }} {{ cardInfo.card_date }}</div>
      <div class="case-header-btn" @click="showOtherData" style="border: 1px solid #f4f4f4">查看补充资料</div>
    </div>
    <div v-if="cardloadStatus == 'load'" class="load-info" ><i class="el-icon-loading"></i>加载中</div>
    <template v-else >
<!--      图像卡-->
      <div class="case-detail-warp-tuxiang" v-if="cardInfo.type_id == 4">
        <img class="pizhu-cover" :src="cardInfo.pizhu_img" alt="">
        <div class="d-flex-between tuxiang-title">
          <div class="tuxiang-title-txt">正在进行的诊疗：<span>{{ cardInfo.being_treatment }}</span></div>
          <div class="tuxiang-title-txt">复诊次数：<span>{{ cardInfo.fz_cc }}</span></div>
        </div>
        <div class="tuxiang-cont">
          <div v-for="(item,index) in cardInfo.image_card_list" class="tuxiang-item">
            <div class="tuxiang-title-txt">图片{{ index + 1 }}</div>
            <div class="d-flex-warp">
              <el-image
                v-for="(subItem,subIndex) in item.img"
                :preview-src-list="item.img"
                :src="subItem"
                class="tuxiang-item-img"
                fit="cover"
                style="width: 149px; height: 150px">
              </el-image>
            </div>
            <div class="tuxiang-title-txt">{{ item.text }}</div>
          </div>
        </div>
      </div>
<!--      设计单-->
      <div class="case-detail-warp" v-else-if="cardInfo.type_id == 5">
        <img class="design-detail-img" :src="cardInfo.shejidan_img" alt="">
        <img class="design-detail-img-cover" :src="cardInfo.pizhu_img" alt="">
      </div>
      <div class="case-detail-warp" v-else>
        <img class="pizhu-cover" :src="cardInfo.pizhu_img" alt="">
        <div class="case-detail-img">
          <div class="case-detail-img-line">
            <el-image
              :preview-src-list="[cardInfo.cemian_pic]"
              :src="cardInfo.cemian_pic"
              class="case-detail-img-item caseImg-3-l">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zhengmian_pic]"
              :src="cardInfo.zhengmian_pic"
              class="case-detail-img-item caseImg-3-l">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zhengmian_weixiao_pic]"
              :src="cardInfo.zhengmian_weixiao_pic"
              class="case-detail-img-item caseImg-3-l">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
          </div>
          <div class="case-detail-img-line">
            <el-image
              :preview-src-list="[cardInfo.youce_yaohe_pic]"
              :src="cardInfo.youce_yaohe_pic"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zhengwei_yaohe_pic]"
              :src="cardInfo.zhengwei_yaohe_pic"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zuoce_yaohe_pic]"
              :src="cardInfo.zuoce_yaohe_pic"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
          </div>
          <div class="case-detail-img-line">
            <el-image
              :preview-src-list="[cardInfo.quanjing_pic]"
              :src="cardInfo.quanjing_pic"
              class="case-detail-img-item caseImg-1">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
          </div>
          <div class="case-detail-img-line">
            <el-image
              :preview-src-list="[cardInfo.ceweimian_x_pic]"
              :src="cardInfo.ceweimian_x_pic"
              class="case-detail-img-item caseImg-2">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <div>
              <div class="case-detail-img-line">
                <el-image
                  :preview-src-list="[cardInfo.shanglingyalie_pic]"
                  :src="cardInfo.shanglingyalie_pic"
                  class="case-detail-img-item caseImg-3-s">
                  <div slot="error" class="image-slot">
                    <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                  </div>
                </el-image>
              </div>
              <div class="case-detail-img-line" style="margin-bottom: 0">
                <el-image
                  :preview-src-list="[cardInfo.xialingyalie_pic]"
                  :src="cardInfo.xialingyalie_pic"
                  class="case-detail-img-item caseImg-3-s">
                  <div slot="error" class="image-slot">
                    <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                  </div>
                </el-image>
              </div>
            </div>
          </div>
          <div class="case-detail-img-line">
            <el-image
              :preview-src-list="[cardInfo.fuhe_fugai_pic]"
              :src="cardInfo.fuhe_fugai_pic"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zhengmian_kaikou_zhao]"
              :src="cardInfo.zhengmian_kaikou_zhao"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
            <el-image
              :preview-src-list="[cardInfo.zhengmian_yangshi_pic]"
              :src="cardInfo.zhengmian_yangshi_pic"
              class="case-detail-img-item caseImg-3-s">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
              </div>
            </el-image>
          </div>
        </div>
        <div class="case-detail-info" style="margin-top: 10px">
          <div class="case-detail-info-line">
            <div class="case-info-name">姓名</div>
            <div class="case-info-cont">{{ cardInfo.patient.name }}</div>
          </div>
          <div class="case-detail-info-line">
            <div class="case-info-name">病例年龄</div>
            <div class="case-info-cont">{{ cardInfo.patient.age_text }}</div>
          </div>
          <div class="case-detail-info-line">
            <div class="case-info-name">首诊主诉</div>
            <div class="case-info-cont">{{ cardInfo.patient.case_info }}</div>
          </div>
          <div v-if="cardInfo.type_id == 2 || cardInfo.type_id == 3" class="case-detail-info-line">
            <div class="case-info-name">{{ cardInfo.type_id == 2 ? '复诊' : '会诊' }}情况</div>
            <div class="case-info-cont">{{ cardInfo.being_treatment }}</div>
          </div>
          <div class="case-detail-info-line">
            <div class="case-info-name">
              {{ cardInfo.patient.confirm_first_case_type_text ? '确认' : '期望' }}套餐类型
            </div>
            <div class="case-info-cont">{{
                cardInfo.patient.confirm_first_case_type_text ? cardInfo.patient.confirm_first_case_type_text : cardInfo.patient.first_case_type_name
              }}
            </div>
          </div>
        </div>
        <div class="case-detail-info" style="margin-top: 10px">
          <div class="case-detail-info-title d-flex-between">
            <div class="case-info-cont">病历记录</div>
          </div>
          <div class="ill-part">
            <div class="case-info-name">难度标记</div>
            <div class=" d-flex-between ill-grey-bg">
              <div class="black-14" style="text-align: left"><span v-if="cardInfo.patient.difficulty_level">{{ cardInfo.patient.difficulty_level }}级</span></div>
            </div>
          </div>
          <div class="ill-part" v-if="cardInfo.type_id != 2 && cardInfo.type_id != 3">
            <div class="case-info-name">首诊牙列期</div>
            <div class="ill-grey-bg d-flex-between">
              <div class="black-14" v-for="item in writeCode.yalieqi" :class="cardInfo.yalieqi == item.name ? 'ill-on' : ''">{{ item.name }}</div>
            </div>
          </div>
          <div class="ill-part" v-if="cardInfo.type_id != 2 && cardInfo.type_id != 3">
            <div class="case-info-name">首诊牙列替换完成时间</div>
            <div class="ill-grey-bg d-flex-between">
              <div class="black-14" v-for="item in writeCode.yalietihuanwanchengshijian" :class="cardInfo.yalie_tihuan_finish_time == item.name ? 'ill-on' : ''">{{ item.name }}</div>
            </div>
          </div>
          <div class="ill-part" v-if="cardInfo.type_id != 2 && cardInfo.type_id != 3">
            <div class="case-info-name">首诊牙列拥挤度</div>
            <div class="small-grey-line d-flex-between">
              <div class="black-14">上颌</div>
              <div class="ill-grey-bg d-flex-between">
                <div class="black-14" v-for="item in writeCode.shangheyalieyongjidu" :class="cardInfo.shanghe_yalie_yongji_rate == item.name ? 'ill-on' : ''">{{ item.name }}</div>
              </div>
            </div>
            <div class="small-grey-line d-flex-between">
              <div class="black-14">下颌</div>
              <div class="ill-grey-bg d-flex-between">
                <div class="black-14" v-for="item in writeCode.xiaheyalieyongjidu" :class="cardInfo.xiahe_yalie_yongji_rate == item.name ? 'ill-on' : ''">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="ill-part">
            <div class="case-info-name">侧貌面型</div>
            <div class="ill-grey-bg d-flex-between">
              <div class="black-14" v-for="item in writeCode.cemaomianxing" :class="cardInfo.cemao_mianxing == item.name ? 'ill-on' : ''">{{ item.name }}</div>
            </div>
          </div>
          <div class="ill-part" v-if="cardInfo.type_id != 2 && cardInfo.type_id != 3">
            <div class="case-info-name">生长评估期</div>
            <img alt="" src="@/assets/img/case_management/cs-table.png" style="width: 100%;margin-bottom: 10px">
            <div class=" d-flex-between ill-grey-bg" >
              <div class="black-14" style="text-align: left">{{ cardInfo.shengzhangqi_pinggu?cardInfo.shengzhangqi_pinggu: writeCode.shengzhangqipinggu[0].name}}</div>
            </div>
          </div>
          <div class="ill-part">
            <div class="case-info-name">龋齿</div>
            <div class="ill-grey-bg d-flex-between">
              <div class="black-14" v-for="item in writeCode.quchi"  @click="writeChange('quchi',item.name)" :class="cardInfo.quchi == item.name ? 'ill-on' : ''">{{ item.name }}</div>
            </div>
          </div>
          <div class="ill-part">
            <div class="case-info-name">诊疗建议</div>
            <textarea v-model="cardInfo.treat_proposal" class="black-14 ill-grey-textarea"></textarea>
          </div>
        </div>
      </div>
    </template>
    <el-dialog
        :visible.sync="showSuggestDialog"
        custom-class="take-dialog"
        width="834px">
      <div slot="title" class="dialog-title">治疗建议
        <div :class="cardInfo.type_id == 1?'dot-shouzhen' :
                     cardInfo.type_id == 2?'dot-fuzhen' :
                     cardInfo.type_id == 3?'dot-huizhen' :
                     cardInfo.type_id == 4?'dot-tuxiang' :
                     cardInfo.type_id == 5?'dot-qixie' :
                     cardInfo.type_id == 6?'dot-jiaozhi' : 'dot-yinxing'" class="card-dot" style="margin: 0 8px 0 10px"></div>
        <div class="black-14">{{ cardInfo.type_name }} {{ cardInfo.card_date }}</div>
      </div>
      <textarea v-model="treatProposal" :draggable="false" class="suggest-textarea"
                placeholder="请填写治疗建议"></textarea>
      <div class="take-dialog-bottom">
        <div class="take-dialog-close" @click="showSuggestDialog = false">取消</div>
        <div class="take-dialog-open" @click="submitSuggest">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {GetCaseCardInfo, GetListByTypeCode, SaveSuggest} from "@/http/api";

export default {
  name: "Detail",
  props: {
    id: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      caseImgUrl: [
        require('@/assets/img/test1.jpg'),
        require('@/assets/img/test2.jpg'),
        require('@/assets/img/test3.jpg')
      ],
      cardInfo: {},
      showSuggestDialog: false,
      treatProposal: '',
      writeCode:{},
      cardloadStatus:'',
      cardId:null,
      member: JSON.parse(localStorage.getItem('member')),
    }
  },
  mounted() {
    GetListByTypeCode({type_code:['app_patient_difficulty_level','yalieqi','yalietihuanwanchengshijian','shangheyalieyongjidu','xiaheyalieyongjidu','cemaomianxing','shengzhangqipinggu','quchi']})
        .then(res=>{
          this.writeCode = res.data
        })
  },
  methods: {
    init(id) {
      if(id) this.cardId = id
      this.cardloadStatus = 'load'
      GetCaseCardInfo({id: this.cardId}).then(res => {
        this.cardInfo = res.data
        this.treatProposal = res.data.treat_proposal
        if(this.$route.query.meeting_id){
          this.$store.commit('breadChange', {
            name: '会诊咨询',
            isBack: true
          })
        }else{
          let url = ''
          if(res.data.patient.doctor_id != this.member.id){
            url = '/mentor_case_management?doctor_id=' + res.data.patient.doctor_id + '&id=' + res.data.patient.id
          }else{
            url = '/case_management?id=' + res.data.patient.id
          }
          this.$store.commit('breadChange', {
            name:  this.cardInfo.patient.name + '的资料卡咨询',
            isBack: true,
            url:url
          })
        }

        this.cardloadStatus = ''
      })
    },
    openSuggest() {
      this.showSuggestDialog = true
    },
    submitSuggest() {
      this.showSuggestDialog = false
      SaveSuggest({id: this.cardInfo.id, treat_proposal: this.treatProposal}).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '治疗意见保存成功'
          })
          this.init()
        }else{
          this.$message({
            type: 'error',
            message: res.message[0]
          })
        }
      })
    },
    showOtherData(){
      this.$parent.openOtherData()
    }
  }
}
</script>

<style scoped src="../../../assets/css/case.css"></style>
